import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from "react-router";
import {registerLocale} from "react-datepicker";
import {ptBR} from "date-fns/locale/pt-BR";
import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaEraser, FaFileExcel, FaSearch} from "react-icons/fa";
import {Card} from "../../../../components/card/card.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import InputDatetime from "../../../../components/input/input-datetime.jsx";
import CloneTable from "../components/CloneTable.jsx";
import projectUtils from "../../../../utils/project-utils.js";

const filterState = {
    dt_ini: null,
    dt_end: null,
    plate: "",
    verified: {value: "all", label: "Todos"},
    corporation: {value: "allcities", label: "Todos"},
    reasons: "",
    last_notification: true
}

const ClonesList = () => {
    const [filters, setFilters] = useState(filterState);
    const [search, setSearch] = useState(0);
    const [isLoading, setIsLoading] = useState()

    registerLocale('pt-BR', ptBR);

    const tableRef = useRef();
    const [searchParams] = useSearchParams();

    useEffect(() => {
        const plate = searchParams.get('plate');
        if (plate) {
            setFilters({...filters, plate: plate, last_notification: false});
            setSearch(prev => ++prev);
        }

        window.addEventListener("keydown", e => {
            if (e?.key === "Enter") setSearch(prev => ++prev);
            if (e?.key === "Escape") clearFilter();
        })
    }, []);



    const handleFilters = (element) => {
        let {id, value, checked, type} = element.target;

        if (type === "checkbox") value = checked;
        if (id === "plate") value = value.toUpperCase();
        setFilters(prev => ({...prev, [id]: value}));
    }

    const handleSelect = (value, item) => setFilters(prev => ({...prev, [item]: value}));

    const handleDate = (value, item) => setFilters(prev => ({...prev, [item]: value}));

    const clearFilter = () => {
        setFilters(filterState);
        setSearch(prev => ++prev);
    }

    const exportData = () => {
        const csvMaker = (data) => Object.values(data).join(';');

        const array = [];
        tableRef.current.api.forEachNodeAfterFilterAndSort(({data}) => {
            const cloneArray =  {
                "Data/Hora": data.date_notification,
                Total: data.total,
                Placa: data.plate.formattedValue,
                Verificado: data.verified ? "Sim" : "Não",
                Natureza: data.reasons,
                "Município 1": data.citynamea,
                "Município 2": data.citynameb
            };

            if (!data.total) delete cloneArray.Total;
            array.push(cloneArray);
        });

        projectUtils.exportCsvData(csvMaker, array)
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>Clones</Template.Title>
                <Button target="success" className="ms-2" onClick={exportData} title="Exportar">
                    <FaFileExcel/> Exportar
                </Button>
            </Template.Header>
            <Template.Body className="flex flex-col space-y-2">
                <Card className={"mb-2"}>
                    <Card.Body>
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-3">
                                <SelectComponent
                                    value={filters.corporation}
                                    options={[
                                        {value: "mycity", label: "Minha corporação"},
                                        {value: "allcities", label: "Todos"}
                                    ]}
                                    label={"Corporação"}
                                    onChange={(value) => handleSelect(value, "corporation")}
                                />
                            </div>
                            <div className="col-span-3">
                                <SelectComponent
                                    value={filters.verified}
                                    options={[
                                        {value: "all", label: "Todos"},
                                        {value: "true", label: "Sim"},
                                        {value: "false", label: "Não"}
                                    ]}
                                    label={"Verificado"}
                                    onChange={(value) => handleSelect(value, "verified")}
                                />
                            </div>
                            <div className="col-span-2">
                                <InputDatetime
                                    id={"dt_ini"}
                                    selected={filters.dt_ini}
                                    label={"Data/hora inicial"}
                                    onChange={(date) => handleDate(date, "dt_ini")}
                                    dateFormat={"LL"}
                                />
                            </div>
                            <div className="flex justify-start gap-4 col-span-4">
                                <InputDatetime
                                    classNameWrapper={"w-full"}
                                    id={"dt_end"}
                                    selected={filters.dt_end}
                                    label={"Data/hora final"}
                                    onChange={(date) => handleDate(date, "dt_end")}
                                    dateFormat={"LL"}
                                />
                                <InputCheckbox
                                    className={"w-[302px]"}
                                    id="last_notification" label="Somente última notificação"
                                    checked={filters.last_notification} onChange={handleFilters}/>
                            </div>
                            <div className="col-span-6">
                                <InputForm id="reasons" label="Naturezas" value={filters.reasons}
                                           onChange={handleFilters}/>
                            </div>
                            <div className="col-span-6">
                                <div className="flex justify-start gap-4">
                                    <InputForm id="plate" label="Placa" value={filters.plate} onChange={handleFilters} classNameWrapper={"w-full"}/>

                                    <div className={"flex gap-2"}>
                                        <Button target="primary-outline" title="Limpar" onClick={clearFilter}>
                                            <FaEraser/>
                                        </Button>
                                        <Button title="Buscar" onClick={() => setSearch(prev => ++prev)} >
                                            <FaSearch />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>

                <CloneTable filters={filters} search={search} tableRef={tableRef} setIsLoading={setIsLoading}/>

            </Template.Body>
        </Template>
    );
};

export default ClonesList;